import HealthCareDisparityMap from './HealthCareDisparityMap';

export default HealthCareDisparityMap;
